import React from 'react';
import { Container, Typography, Box, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"League Spartan", sans-serif', // Your local font
    },
});

function Contact() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>


                <Typography variant="h4" component="h2" gutterBottom>
                    Contact Us
                </Typography>
                <Typography paragraph>
                    At Kerdos, we value our users and strive to provide outstanding support and guidance every step of the way. Whether you have questions about using our wallet, need help with an issue, or just want to learn more about our services, we're here to help!
                </Typography>

                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Get in Touch
                    </Typography>
                    <Typography paragraph>
                        For any inquiries or assistance, please don't hesitate to reach out to our dedicated support team. We’re available to provide fast, reliable, and secure support to ensure your experience with Kerdos is smooth and enjoyable.
                    </Typography>
                    <Typography paragraph>
                        Email: Reach out to us at <a href="mailto:info@kerdosapp.io">info@kerdosapp.io</a> for general inquiries, feedback, and support requests.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Support Channels
                    </Typography>
                    <Typography paragraph>
                        Our commitment to your security and satisfaction extends through our support channels. Each request is treated with the highest priority, whether it's resolving technical issues, answering account-related questions, or providing information about new features.
                    </Typography>
                    <Typography paragraph>
                        <strong>1. Technical Support:</strong> If you’re experiencing any technical difficulties, such as transaction issues or account access problems, email our technical support team at <a href="mailto:info@kerdosapp.io">info@kerdosapp.io</a>. We aim to resolve issues as swiftly as possible, with a dedicated team ready to assist.
                    </Typography>
                    <Typography paragraph>
                        <strong>2. Account Assistance:</strong> For account-related questions, our account assistance specialists are available to help you with any inquiries about security, transactions, or verification.
                    </Typography>
                    <Typography paragraph>
                        <strong>3. Feedback and Suggestions:</strong> We’d love to hear your thoughts! If you have any feedback or ideas on how we can improve Kerdos, let us know by emailing <a href="mailto:info@kerdosapp.io">info@kerdosapp.io</a>.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Our Commitment to You:
                    </Typography>
                    <Typography paragraph>
                        Your trust and satisfaction are at the core of our values. Every contact you make with us is secure and confidential, with a team dedicated to maintaining the privacy and integrity of your information. We’re here to ensure that your experience with Kerdos is not just a transaction but a relationship you can rely on.
                    </Typography>
                    <Typography paragraph>
                        Thank you for choosing Kerdos. We look forward to assisting you!
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
}

export default Contact;
